// one request singleton
// const trace = false

// import Log from "./logging"

// const log = new Log ()
// log.name = "Request"
// log.silent = false;

let RequestID = 1

const request = (type, url, data, id) => new Promise((resolve, reject) => {
  const req = new XMLHttpRequest()

  req.onload = () => {
    // log.info ("loaded response: ", url, id, RequestID)
    if (req.status === 200) {
      if (id === null) {
        // log.info ("ignoring id")
        resolve(JSON.parse(req.response))
      } else {
        if (id < RequestID) {
          return
        }
        if (req.response !== '&nbsp;') {
          // log.info ("response:", req)
          try {
            // log.info ("resolving", resolve)
            const response = JSON.parse(req.response)
            resolve(response)
          } catch (err) {
            resolve(req.response)
          }
        }
      }
    } else {
      reject(req.statusText)
    }
  }

  // Handle network errors
  req.onerror = () => {
    reject('Network Error')
  }

  req.open(type, url)

  if (data) {
    req.setRequestHeader(
      'Content-Type',
      'application/json;charset=UTF-8'
    )
  }

  // Make the request
  try {
    req.send(data)
  } catch (err) {
    console.log(
      'error: chunked encoding?',
      err.contains('et::ERR_INCOMPLETE_CHUNKED_ENCODING'),
      err
    )
  }
})

const Request = {
  getRequestID: () => {
    RequestID += 1
    return RequestID
  },

  get: url => request('GET', url),

  post: (url, data, id) =>
    // log.info ("POST: ", url, data)
    request('POST', url, data, id),

  put: (url, data) => request('PUT', url, data),

  delete: (url, data) => request('DELETE', url, data)
}

export default Request
